<div class="backgroundColor mine-shaft base">
  <section class="container-fluid backgroundColor mine-shaft base d-flex align-items-center position-relative top-119">
    <div class="col-md-12">
      <div id="row" class="container">
        <div class="row pt-20">
          <div class="col-md-12">
            <div class="bg-yellow-gradient text-shadow">
              <h1 class="py-2 m-6 mt-16 mb-16">Noivas</h1>
            </div>
          </div>
        </div>
        <div class="row text-center">
          <div class="col-sm-3 col-md-6 col-lg-3 col-xl-3 col-12 mt-3">
            <div class="card border-const-2" id="padding-right">
              <div class="card-body">
                <h2 class="text-white text-center">Selecione a marca que pretende visualizar</h2>
              </div>
              <button class="py-3 btn-grad" (click)="uncheckAll()">Limpar Seleção</button>
              <ul class="list-group list-group-flush text-white filter-height">
                <ng-container *ngFor="let item of marcas; let i = index;">
                  <li class="list-group-item d-table text-left">
                    <span>{{item}}</span>
                    <input class="form-control col-3" type="checkbox" style="height: 25px;" [checked]="true" (click)="checkMarcas(item)" id="ch{{i}}">
                  </li>
                </ng-container>
              </ul>
            </div>
          </div>
          <ng-container *ngFor="let item of produtos">
            <div class="col-sm-3 col-md-6 col-lg-3 col-xl-3 col-12 d-flex justify-content-center mt-3">
              <div class="card" style="width: 16rem;">
                <img src="https://{{apiUrl}}/api/produtos/image/{{item.id}}/{{item.media.split(';')[0]}}" class="card-img-top backgroundColor white base img-fluid" alt="...">
                <div class="card-body d-flex flex-column">
                  <h2 class="card-text text-white">{{item.nome}}</h2>
                  <p class="card-text text-white mt-auto d-flex align-items-center justify-content-center"><fa-icon [icon]="faEuroSign" class="fal fa-euro-sign textColor amber base mr-3"></fa-icon>Sob Consulta</p>
                  <a href="/produtos/modelo?id={{item.id}}" class="btn btn-primary mt-auto mx-auto">Ver Mais</a>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="d-flex justify-content-center flex-column flex-wrap">
        <app-pagination [(pags)]="pags" [(current)]="current"></app-pagination>
      </div>
    </div>
  </section>
</div>